import React from 'react'

import CreateIcon from 'assets/icons/plus-circle-icon.svg?component'
import ExploreIcon from 'assets/icons/menu-browse-icon.svg?component'
import ShopIcon from 'assets/icons/shoppingcart-icon-navbar.svg?component'
import ResourceIcon from 'assets/icons/resource-icon.svg?component'
import WalletIcon from 'assets/icons/wallet-gray.svg?component'
import RightIcon from 'assets/icons/arrow-right-white-medium.svg?component'

// styles
import styles from './index.module.scss'

const MobileMenuItem = props => {
  const { type, onClick } = props

  const getTypeName = () => {
    switch (type) {
      case 'create':
        return 'Create'
      case 'explore':
        return 'Explore'
      case 'shop':
        return 'Shop'
      case 'resources':
        return 'Resources'
      case 'wallet':
        return 'My Wallets'
      default:
        return 'Create'
    }
  }

  const getTypeDescription = () => {
    switch (type) {
      case 'create':
        return 'Mint artwork or publish a store item'
      case 'explore':
        return 'Artworks, creators, and collections'
      case 'shop':
        return 'Browse items for sale'
      case 'resources':
        return 'User guides and tutorials'
      case 'wallet':
        return 'Manage your wallets'
      default:
        return 'Create'
    }
  }

  const getTypeIcon = () => {
    switch (type) {
      case 'create':
        return <CreateIcon />
      case 'explore':
        return <ExploreIcon />
      case 'shop':
        return <ShopIcon />
      case 'resource':
        return <ResourceIcon />
      case 'wallet':
        return <WalletIcon />
      case 'resources':
        return <ResourceIcon />
      default:
        return <div />
    }
  }

  return (
    <div className={styles.container} onClick={onClick}>
      <div className="w-full flex justify-around">
        <div className="w-full flex items-center">
          <div className={styles.icon}>
            <div className="flex items-center">{getTypeIcon()}</div>
          </div>
          <div className="ml-[15px]">
            <div className={styles.title}>{getTypeName()}</div>
            <div className={styles.subtitle}>{getTypeDescription()}</div>
          </div>
        </div>
        <div className="flex items-center">
          <RightIcon />
        </div>
      </div>
    </div>
  )
}

export default MobileMenuItem
